import { render } from "./Webview.vue?vue&type=template&id=46ea6e16&ts=true"
import script from "./Webview.vue?vue&type=script&lang=ts"
export * from "./Webview.vue?vue&type=script&lang=ts"

import "./Webview.vue?vue&type=style&index=0&id=46ea6e16&lang=scss"

import exportComponent from "D:\\封面新闻\\activity\\ssccloudtour\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__